<div
  class="row"
  *ngIf="
    notificationPreferences != null && requiredNotifications != null && enableTestNotifications
  ">
  <div class="col-12">
    <label>Select a Notification to Trigger</label>
  </div>
  <div class="col-6">
    <select class="form-control" [(ngModel)]="selectedNotification">
      <ng-container *ngFor="let notification of notificationPreferences.Notifications">
        <option *ngFor="let pref of notification.Preferences" [value]="pref.NotificationId">
          {{ pref.NotificationName }}
        </option>
        <option *ngFor="let required of requiredNotifications" [value]="required.Id">
          {{ required.Name }}
        </option>
      </ng-container>
    </select>
  </div>
  <div class="col-6">
    <button (click)="sendTest()" class="btn btn-primary">Send Test Notification</button>
  </div>
</div>
<div class="row">
  <div class="col-12 col-md-8">
    <div class="row" *ngIf="notificationPreferences != null">
      <div class="col-8">All account security notifications will be sent via email.</div>
      <div class="col-4">
        <lib-checkbox
          data-testid="security-switch"
          label="Add SMS Notifications"
          [disabled]="!hasPhoneNumber"
          [ngModel]="notificationPreferences.SmsForSecurity"
          (ngModelChange)="securityChanged($event)"></lib-checkbox>
      </div>
    </div>
    <hr />
    <ng-container *ngIf="displayModel != null && displayModel.length > 0">
      <ng-container *ngFor="let category of displayModel">
        <div
          class="toggle-grid mt-4"
          *ngIf="canDisplayCategory(category.name) && category.groups.length > 0">
          <div>
            <p class="fw-bold">{{ category.name }}</p>
          </div>
          <div>
            <p class="fw-bold">Email</p>
          </div>
          <div>
            <p class="fw-bold">SMS</p>
          </div>
          <ng-container *ngFor="let pref of category.groups">
            <ng-container *ngIf="canDisplayRow(pref)" data-testid="optionalNotificationRow">
              <div class="fw-bold">
                {{ pref.name }}
              </div>
              <div>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input switch"
                    [id]="'chk_email_' + pref.id"
                    type="checkbox"
                    role="switch"
                    (ngModelChange)="emailChanged(pref, $event)"
                    [ngModel]="pref.sendEmail" />
                </div>
              </div>
              <div>
                <div class="form-check form-switch">
                  <input
                    *ngIf="pref.allowSms"
                    data-testid="optionalSmsSwitch"
                    [disabled]="!hasPhoneNumber"
                    class="form-check-input switch"
                    [id]="'chk_sms_' + pref.id"
                    type="checkbox"
                    role="switch"
                    (ngModelChange)="smsChanged(pref, $event)"
                    [ngModel]="pref.sendSms" />
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <div class="row mt-5">
      <div class="col-12">
        <small
          >Note: We do our best to ensure timeliness, accuracy, & receipt of all account
          notifications. Sometimes network issues & other factors limit our ability to get in touch
          in a timely manner.</small
        >
        <small *ngIf="!isEmployeeUser"
          >&nbsp;Please do not hesitate to contact your dedicated Payroll Specialist if you need
          immediate assistance.</small
        >
      </div>
    </div>
  </div>
</div>
